import { Markdown as BaseMarkdown } from '@customerio/hydra-copilot/react';
import { Text } from '@customerio/pluma-components/react';
import '../../markdown.css';

export function Markdown({
  children,
  isAnimating,
  ...rest
}: Omit<React.ComponentProps<typeof Text>, 'children'> & {
  children: string;
  isAnimating?: boolean;
}) {
  return (
    <Text flexDirection="column" gap="100" display="flex" overflowWrap="anywhere" color="active" {...rest}>
      <BaseMarkdown
        isAnimating={isAnimating}
        animated={{
          animation: 'customAnimation',
          duration: 120,
          easing: 'ease-in',
        }}
      >
        {children}
      </BaseMarkdown>
    </Text>
  );
}
